import React from "react";
import { Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  settingAirposDeleteSelector,
  updateAirposDeleteModal,
} from "../../../../store/setting/airpos/delete";
import { AppDispatch } from "../../../../store";
import { fetchDeleteToastCam } from "../../../../store/setting/toascam/delete";

function AirposDeleteModal() {
  const { visible } = useSelector(settingAirposDeleteSelector);
  const dispatch = useDispatch<AppDispatch>();
  const onCancel = () => {
    dispatch(updateAirposDeleteModal(false));
  };
  const onClickDelete = () => {
    dispatch(fetchDeleteToastCam("AirPos"));
  };
  return (
    <Modal
      className="airpos-delete-modal"
      visible={visible}
      onCancel={onCancel}
      footer={
        <>
          <Button onClick={onCancel}>취소</Button>
          <Button onClick={onClickDelete} danger type="primary">
            연동 해제
          </Button>
        </>
      }
    >
      <img
        src={`${process.env.REACT_APP_S3_URL}/1.0/logos/airpos_logo.png`}
        alt="airpos_logo"
      />
      <h1>에어포스 서비스 연동을 해제하시겠습니까?</h1>
      <p>계정 연동을 해제하시겠습니까?</p>
      <p>
        계정 연동을 해제하면 기기 4대도 함께 해제되며, 에어포스 기기들과 연동된
        기능들이 무효화되므로, 각별한 주의를 부탁드립니다.
      </p>
    </Modal>
  );
}

export default AirposDeleteModal;
